// TODO: Remove the need for this file by scanning the templates directory
// and generating the index automatically.

module.exports = [
	/* require('./_empty.js'), */
	require('./DataType-Date.js'),
	require('./DataType-DateTime.js'),
	require('./DataType-Default.js'),
	require('./DataType-Number.js'),
	require('./DataType-PreciseNumber.js'),
	require('./DataType-String.js'),
	require('./DataType-Time.js'),
	require('./Form-Container.js'),
	require('./InputType-Boolean.js'),
	require('./InputType-BridgeSelector.js'),
	require('./InputType-Color.js'),
	require('./InputType-Chart.js'),
	require('./InputType-EmailAddress.js'),
	require('./InputType-EntityDisplay.js'),
	require('./InputType-EntitySelector.js'),
	require('./InputType-EntitySelectorMultiple.js'),
	require('./InputType-FileSelector.js'),
	require('./InputType-ObservationPhoto.js'),
	require('./InputType-GeolocationSelector.js'),
	require('./InputType-GeolocationSelectorWithMap.js'),
	require('./InputType-CloneAction.js'),
	require('./InputType-Diagram.js'),
	require('./InputType-HTML.js'),
	require('./InputType-LabSelector.js'),
	require('./InputType-Link.js'),
	require('./InputType-LineItemSelector.js'),
	require('./InputType-Markdown.js'),
	require('./InputType-MarkdownDisplay.js'),
	require('./InputType-MaterialSelector.js'),
	require('./InputType-MaterialsEntitySelector.js'),
	require('./InputType-SampleTypeSelector.js'),
	require('./InputType-MaterialsHiddenSampleSelector.js'),
	require('./InputType-MaterialsHiddenTestInjector.js'),
	require('./InputType-MaterialsHiddenTestSelector.js'),
	require('./InputType-MaterialsHiddenLineItemSelector.js'),
	require('./InputType-MaterialsSampleSelector.js'),
	require('./InputType-MaterialsQRCodeDisplay.js'),
	require('./InputType-MaterialsTestInjector.js'),
	require('./InputType-MaterialsTestSectionRemover.js'),
	require('./InputType-MaterialsTestSelector.js'),
	require('./InputType-MaterialsLineItemSelector.js'),
	require('./InputType-MaterialsLabSelector.js'),
	require('./InputType-MaterialsTestLabSelector.js'),
	require('./InputType-MaterialsPlantSelector.js'),
	require('./InputType-MaterialsHiddenLabSelector.js'),
	require('./InputType-MediaDetailCards.js'),
	require('./InputType-MixSpecificationSelector.js'),
	require('./InputType-ObjectEditor.js'),
	require('./InputType-ObservationImageSet.js'),
	require('./InputType-ObservationSet.js'),
	require('./InputType-ObservationCardDeck.js'),
	require('./InputType-ObservationTypeSelector.js'),
	require('./InputType-Option.js'),
	require('./InputType-PhoneNumber.js'),
	require('./InputType-PhysicalAssetSelector.js'),
	require('./InputType-Picker.js'),
	require('./InputType-SampleTestAcceptance.js'),
	require('./InputType-PlantSelector.js'),
	require('./InputType-PreciseNumberReadOnly.js'),
	require('./InputType-PrecompiledFileSelector.js'),
	require('./InputType-ProducerSelector.js'),
	require('./InputType-ProductSelector.js'),
	require('./InputType-ProjectSelector.js'),
	require('./InputType-ReadOnly.js'),
	require('./InputType-RichText.js'),
	require('./InputType-SampleHiddenStatusSelector.js'),
	require('./InputType-SampleHiddenTestResult.js'),
	require('./InputType-SampleSelector.js'),
	require('./InputType-SampleStatusSelector.js'),
	require('./InputType-SampleTestResult.js'),
	require('./InputType-Select2.js'),
	require('./InputType-Select2Multiple.js'),
	require('./InputType-Signature.js'),
	require('./InputType-StaticLabel.js'),
	require('./InputType-StaticText.js'),
	require('./InputType-Station.js'),
	require('./InputType-StreetAddress.js'),
	require('./InputType-TabGroupSelector.js'),
	require('./InputType-TabSectionSelector.js'),
	require('./InputType-TextArea.js'),
	require('./InputType-UpdateAwareNumber.js'),
	require('./Recordset-Group.js'),
	require('./Tabular-Group.js'),

	// questionable templates that may not be used
	require('./InputType-ExistingDisabledByDefault.js'),
	require('./InputType-DocumentDate.js'),
	require('./InputType-TemplatedEntityLookup.js'),
];
